import React from 'react';
import { ProfileOutlined } from 'jl-design-system/components/icons/ProfileOutlined';
import styles from './account-button.scss';

interface AccountButtonProps {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  greeting?: string;
  myAccountUrl?: string;
}

export const AccountButton = ({
  onClick,
  greeting,
  myAccountUrl,
}: AccountButtonProps) => {
  return (
    <a
      href={myAccountUrl || '/my-account'}
      onClick={onClick}
      data-test="account-button"
      data-testid="account-button"
      aria-label="Go to your account"
    >
      {greeting && <span className={styles.greeting}>{greeting}</span>}

      <ProfileOutlined
        className={styles.icon}
        dataTestId="account-button-icon"
        size="large"
        title="Go to your account"
      />
    </a>
  );
};
